<template>
  <img
    src="@/assets/images/bugdetector.jpg"
    alt="Bug detector"
    class="border-2 rounded-t-md border-blue-50"
  />
  <div class="bg-blue-50 p-6">
    <p class="text-xl text-center px-6 pt-1 pb-2 uppercase">
      You get professional bug detector and locator today
    </p>
    <p class="text-xl text-center px-6 font-medium">
      NORMALLY1997$ - FOR 1597$(30% DISCOUNT!)
    </p>
  </div>
<!--  <div class="bg-gradient-to-r from-green-400 to-blue-500 p-6 text-white">-->
<!--    <div class="border border-b-0 border-white rounded-t-md w-full flex">-->
<!--      <p class="border-r border-white w-1/2 p-4">1 PROFESSIONAL BUG DETECTOR</p>-->
<!--      <p class="p-4 self-center">1397</p>-->
<!--    </div>-->
<!--    <div class="border border-b-0 border-white w-full flex">-->
<!--      <p class="border-r border-white w-1/2 p-4">-->
<!--        2 PROFESSIONAL BUG DETECTORS-->
<!--      </p>-->
<!--      <p class="p-4 self-center">2694 (1347$ PER 1)</p>-->
<!--    </div>-->
<!--    <div class="border border-white w-full flex rounded-b-md">-->
<!--      <p class="border-r border-white w-1/2 p-4">-->
<!--        <span class="px-2 py-0.5 rounded-sm bg-red-700 text-xs text-white"-->
<!--          >BEST DEAL</span-->
<!--        >-->
<!--        - protect personal privacy<br />-->
<!--        3 PROFESSIONAL BUG DETECTOR-->
<!--      </p>-->
<!--      <p class="p-4 self-center">3997 ( 1332$ PER 1)</p>-->
<!--    </div>-->
<!--  </div>-->
  <div class="bg-blue-50 p-6 rounded-b-md">
    <div id="order"></div>
  </div>
</template>

<script>
export default {
  name: "Order",
  created() {},
};
</script>

<style lang="scss"></style>
